
global.endor.checkout.core.init();